const DEFAULT_VALUE = true;
export const isSlidesLoopEnabled = slider => {
  if (typeof slider?.loop === 'object') {
    return DEFAULT_VALUE;
  }
  return slider?.loop ?? DEFAULT_VALUE;
};
//# sourceMappingURL=isSlidesLoopEnabled.js.map